if (!customElements.get('cart-drawer-upsell')) {
  class CartDrawerUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-upsell-track]');
      this.prev = this.querySelector('[data-upsell-prev]');
      this.next = this.querySelector('[data-upsell-next]');

      if (!this.track) return;

      this.prev?.addEventListener('click', () => this.scrollBySlide(-1));
      this.next?.addEventListener('click', () => this.scrollBySlide(1));
      this.track.addEventListener('scroll', () => this.updateButtons(), { passive: true });

      this.updateButtons();
    }

    scrollBySlide(direction) {
      const slide = this.track.querySelector(':scope > *');
      if (!slide) return;

      this.track.scrollBy({
        left: direction * (slide.offsetWidth + 12),
        behavior: 'smooth',
      });
    }

    updateButtons() {
      if (!this.track) return;

      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;

      if (this.prev) this.prev.disabled = left <= 2;
      if (this.next) this.next.disabled = left >= maxScroll - 2;
    }
  }

  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
}
